import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import StyledSvgIconWrapper from "./wrappers/StyledSvgIconWrapper";

export const MenuNotificationsIcon = ({
  monochrome,
  ...props
}: { active?: boolean; monochrome?: boolean; activeColor?: string } & SvgIconProps) => {
  return (
    <StyledSvgIconWrapper {...props} width="30" height="30" viewBox="0 0 30 30">
      <svg width="56" height="64" viewBox="0 0 56 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M39.95 14.6C43.9817 14.6 47.25 11.3317 47.25 7.3C47.25 3.26832 43.9817 0 39.95 0C35.9183 0 32.65 3.26832 32.65 7.3C32.65 11.3317 35.9183 14.6 39.95 14.6Z"
          fill="#32B88E"
          className="fill"
        />
        <path
          d="M27.7 2.94C16.69 2.94 9.34 12.12 9.34 21.3V35.98C9.34 43.32 2 50.66 2 50.66H53.39C53.39 50.66 46.05 43.32 46.05 35.98V19.99"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : ""}
        />
        <path
          d="M38.21 51.33C38.21 57.14 33.5 61.84 27.7 61.84C21.9 61.84 17.19 57.13 17.19 51.33"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : ""}
        />
      </svg>
    </StyledSvgIconWrapper>
  );
};
